export default [
  {
    path: '/admin/trade-in',
    name: 'trade-in',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/trade-in/index.vue')
  },
  {
    path: '/admin/trade-in/create',
    name: 'trade-in-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/trade-in/create.vue')
  },
  {
    path: '/admin/trade-in/:id/edit',
    name: 'trade-in-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/trade-in/edit.vue')
  }
]
